@if(!isLoading && !error){
  <div data-e2e="loading-container" class="loading">
    <div class="TruckLoader">
      <div data-e2e="loading-msg" class="load">Carregando...</div>
      <div class="TruckLoader-cab"></div>
      <div class="TruckLoader-smoke"></div></div>
      <hr />
    </div>
  }

  @if(error){
    <div class="page-wrap d-flex flex-row align-items-center">
      <div class="container">
        <div class="row justify-content-center">
          @if (error) {
            <div class="col-md-12 text-center">
              <span data-e2e="error-440" class="display-1 d-block">Erro</span>
              <div id="error" class="mb-4 lead">{{message}}</div>
            </div>
          }
        </div>
      </div>
    </div>
  }
